import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import D13nStore from 'stores/plugins/d13n';
import { t } from 'services/translation';
import MobileMixin from './mobile_mixin';
import { Location } from './location';
import styled from '@emotion/styled';

export const ConfirmationSection = styled.div`
  font-size: 16px;
  line-height: 1.6;
  margin-top: 24px;
  margin-bottom: 24px;
`;

const ConfirmationPending = createReactClass({
  displayName: 'ConfirmationPending-Plugins',

  mixins: [MobileMixin, PureRenderMixin],

  propTypes: {
    guide_full_name: PropTypes.string.isRequired,
    footer_content: PropTypes.node,
    custom_title: PropTypes.string,
    custom_body: PropTypes.string,
  },

  _renderCreditCardInfo() {
    if (!this.props.paid_in_cash && this.props.show_cc_info) {
      return (
        <ConfirmationSection>
          {t('YOUR_CREDIT_CARD_WILL_NOT_BE_CHARGED_UNTIL_THAT_TIME')}.
        </ConfirmationSection>
      );
    }
  },

  _renderDefaultTitleText() {
    return (
      <div>
        <h1>
          <span className="titleRow" data-testid="title-row">
            {t('YOUR_REQUEST_HAS_BEEN_SUCCESSFULLY_SUBMITTED')}.
          </span>
        </h1>
      </div>
    );
  },

  _renderCustomTitleText(customCopy) {
    return (
      <h1>
        <div
          className="titleRow contains-brand-link"
          dangerouslySetInnerHTML={{ __html: customCopy } /* // nosemgrep */}
        />
      </h1>
    );
  },

  _renderDefaultBodyText() {
    const {
      guide_full_name,
      has_resource,
      resource_name,
      custom_body,
      location,
      custom_locations_enabled,
      online,
    } = this.props;

    return (
      <div className="Confirmation-Body">
        <h3>{t('WERE_JUST_AS_EXCITED_AS_YOU_ARE')}...</h3>
        <ConfirmationSection
          dangerouslySetInnerHTML={{
            __html: t('NOT_A_CONFIRMED_BOOKING', '', {
              name: has_resource ? resource_name : guide_full_name,
            }),
          }}
        />

        {this._renderCreditCardInfo()}
        {custom_locations_enabled && !online && (
          <Location location={location} />
        )}
        {custom_body && (
          <ConfirmationSection
            className="contains-brand-link"
            dangerouslySetInnerHTML={{ __html: custom_body }}
          />
        )}

        <hr className="separator" />
        <h3>{t('WHAT_HAPPENS_NEXT')}</h3>
        <p>
          {t(
            'WE_WILL_LET_YOU_KNOW_VIA_EMAIL_AS_SOON_AS_THE_BOOKING_IS_CONFIRMED'
          )}
          .
        </p>
      </div>
    );
  },

  _renderAffiliateText() {
    const { guide_full_name } = this.props;

    return (
      <div className="Confirmation-Body">
        <ConfirmationSection
          dangerouslySetInnerHTML={{
            __html: t('AFFILIATE_NOT_CONFIRMED_BOOKING', '', {
              name: guide_full_name,
            }),
          }}
        />

        <hr className="separator" />
        <h3>{t('WHAT_HAPPENS_NEXT')}</h3>
        <p>{t('AFFILIATE_EMAIL_NOTICE')}</p>
      </div>
    );
  },

  render() {
    const { custom_title, footer_content, isBookingAffiliate } = this.props;
    return (
      <div className="Confirmation-Body">
        <div className="Confirmation-Title" data-testid="confirmation-title">
          {custom_title
            ? this._renderCustomTitleText(custom_title)
            : this._renderDefaultTitleText()}
        </div>
        {!isBookingAffiliate
          ? this._renderDefaultBodyText()
          : this._renderAffiliateText()}
        {footer_content && (
          <>
            <hr className="separator" />
            {footer_content}
          </>
        )}
      </div>
    );
  },
});

export default ConfirmationPending;
